(function () {
  var html = document.documentElement;

  if (!('IntersectionObserver' in window)) {
    html.classList.remove('reset-js');
    return;
  }

  var targets = document.querySelectorAll(
    '.reset-loop__title, .reset-ways__title, .reset-meals__title, .reset-faq__title, .reset-cta__title, .rmenu__title, .rgoal__title, .rfp__title'
  );

  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reset-word-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });

  // FAQ entry motion — same trigger-then-play mechanism as above, but the
  // class lands on the section's whole layout wrapper instead of a single
  // heading, since it needs to cascade to several separately-timed pieces
  // (see .reset-faq__reveal in reset-faq.liquid).
  var faqTargets = document.querySelectorAll('.reset-faq__layout');
  if (faqTargets.length) {
    var faqObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reset-faq-in-view');
            faqObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );
    faqTargets.forEach(function (el) {
      faqObserver.observe(el);
    });
  }
})();
